import { css } from "@emotion/react";
import { APP_CONTENT_MAX_WIDTH } from "../constants";

export const styles = {
  wrapper: css`
    width: fit-content;
    max-width: 100%;
    min-width: 100%;
    position: relative;
  `,
  base: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: ${APP_CONTENT_MAX_WIDTH}px;
    gap: var(--spacing-40);
    padding: var(--spacing-32);
  `,
  fillWidth: css`
    margin-left: 0;
    margin-right: 0;
    width: fit-content;
    max-width: 100%;
    min-width: 100%;
  `,
  fillHeight: css`
    flex-grow: 1;
  `,
  condensed: css`
    gap: 0;
  `,
  noPadding: css`
    padding: 0;
  `
};
